export class Submission {
  constructor({ kind, fields, meta = {} }) {
    this.kind = kind;                
    this.fields = { ...fields };      
    this.meta = {
      createdAt: new Date().toISOString(),
      page: typeof window !== "undefined" ? window.location.pathname : "",
      ...meta,
    };
  }

  toJSON() {
    return { kind: this.kind, fields: this.fields, meta: this.meta };
  }

  validate(requiredKeys = []) {
    const missing = requiredKeys.filter((k) => {
      const v = this.fields?.[k];
      return v === undefined || v === null || String(v).trim() === "";
    });
    return { ok: missing.length === 0, missing };
  }
}

/**
 * Helper: builds a Submission from any form state.
 * - kind: string label for the form ("visit", "consultation")
 * - fields: any object
 * - meta: optional context
 */
export const buildSubmission = ({ kind, fields, meta }) =>
  new Submission({ kind, fields, meta });
